import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Royal Route Cab</title>
        <meta
          name="description"
          content="Privacy Policy for Royal Route Cab. Learn how we collect, use, and protect your personal information."
        />
        <meta
          name="keywords"
          content="Royal Route Cab, Cab Rental Service, Taxi Booking, Outstation Cab"
        />
      </Helmet>


    <div
      className="breadcrumb-wrapper section-padding bg-cover"
      style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
    >
      <div className="container-fluid">
        <div className="page-heading">
          
          <h1 className="wow fadeInUp text-center" data-wow-delay=".5s">
            Privacy Policy
          </h1>
        </div>
      </div>
    </div>


   

      {/* Privacy Policy Content */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">
            <div className="col-12 col-md-7">
              <h3 className="title">Privacy Policy – Royal Route Cab</h3>

              <p>
                At <b>Royal Route Cab</b>, we value your privacy and are committed
                to protecting your personal information. This Privacy Policy explains
                how your data is collected, used, stored, and safeguarded when you
                use our services.
              </p>

              <div className="sectionn">
                <p className="highlight darkcolor">Information We Collect:</p>

                <p className="highlight darkcolor">1. Booking Information:</p>
                <p>
                  When you book a cab, we collect details such as your name,
                  phone number, pickup/drop locations, travel dates,
                  passenger count, and payment details.
                </p>

                <p className="highlight darkcolor">2. Travel Details:</p>
                <p>
                  For outstation, corporate, wedding, or group bookings,
                  we may collect itinerary details to ensure smooth service.
                </p>

                <p className="highlight darkcolor">3. Website Usage Data:</p>
                <p>
                  We may collect technical information like IP address,
                  browser type, device info, and visited pages to improve
                  our website and services.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">How We Use Your Information:</p>

                <p className="highlight darkcolor">1. Service Delivery:</p>
                <p>
                  To confirm bookings, assign drivers, and manage rides efficiently.
                </p>

                <p className="highlight darkcolor">2. Communication:</p>
                <p>
                  To send booking confirmations, driver details, updates,
                  and customer support responses.
                </p>

                <p className="highlight darkcolor">3. Improvement:</p>
                <p>
                  To enhance our service quality and customer experience.
                </p>

                <p className="highlight darkcolor">4. Marketing:</p>
                <p>
                  With your consent, we may send offers, discounts, or updates.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Information Sharing:</p>

                <p className="highlight darkcolor">1. Drivers:</p>
                <p>
                  Booking details are shared with assigned drivers to complete your trip.
                </p>

                <p className="highlight darkcolor">2. Legal Requirements:</p>
                <p>
                  Information may be shared if required by law or authorities.
                </p>
              </div>

              <div className="section">
                <p className="highlight darkcolor">Data Security:</p>
                <p>
                  We use reasonable security measures to protect your data,
                  but no system is 100% secure.
                </p>

                <p className="highlight darkcolor">Your Rights:</p>
                <p>
                  You can request access, correction, or deletion of your data
                  and opt out of marketing at any time.
                </p>

                <p className="highlight darkcolor">Policy Updates:</p>
                <p>
                  This policy may be updated occasionally. Changes will be
                  posted on this page.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, contact us:</p>
            <ul>
              <li>
                <b>Phone:</b> <a href="tel:+919529877342">+91 9529877342</a>
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@royalroutecabs.com">booking@royalroutecabs.com</a>
              </li>
              <li>
                <b>Address:</b> Royal Route Cabs,  
Shop Number 57,
Prabhat Colony Opp.<br/>
Panbai International School
Vimladevi Road,<br/>
Santacruz(E) Mumbai Maharashtra-400055.

              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;